import axios from "axios";

export default {
    namespaced: true,
    state: {
        all: [],
    },

    actions: {
        index({ commit }) {
            return axios.get(process.env.VUE_APP_API_URL + 'tanker-floats')
                .then(({ data }) => {
                    commit('setTankerFloats', data);
                });
        },
    },
    getters: {
        getTankerFloatById: (state,getters) => (id) => {
            let tankerFloats = state.all.filter(tankerFloat => {
                return tankerFloat.id === id;
            });
            return tankerFloats !== null ? tankerFloats[0] : null;
        },
    },
    mutations: {
        setTankerFloats(state, tankerfloats) {
            state.all = tankerfloats;
        },
    },
}